import script from "./ItemToRole.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemToRole.vue?vue&type=script&setup=true&lang=js"

import "./ItemToRole.vue?vue&type=style&index=0&id=d9031afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9031afc"]])

export default __exports__